var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsScheduledGroupGridIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Scheduled_Group",
    "data-name": "Scheduled Group",
    cx: 4,
    cy: 4,
    r: 4,
    fill: "#7900ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsScheduledGroupGridIcon);
export default __webpack_public_path__ + "static/media/Reports-scheduledGroup-grid-icon.1fc21d1af7d159669f5ad352159442d2.svg";
export { ForwardRef as ReactComponent };